import { render, staticRenderFns } from "./cashier_header.vue?vue&type=template&id=6d6ef552&scoped=true"
import script from "./cashier_header.vue?vue&type=script&lang=js"
export * from "./cashier_header.vue?vue&type=script&lang=js"
import style0 from "./cashier_header.vue?vue&type=style&index=0&id=6d6ef552&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6ef552",
  null
  
)

export default component.exports